<div class="modal-content" [class.shadow-none]="false">
  <div class="modal-header align-items-start">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">Delete Entity</h2>
    </div>
  </div>
  <div class="modal-body">
    <p>{{ description}}</p>
  </div>
  <div class="modal-footer">
    <div class="button box">
      <app-button
        [label]="'Cancel'"
        [variant]="'outline'"
        class="me-3"
        (clicked)="cancel()"
      />
      <app-button
        [label]="'Delete'"
        [variant]="'primary'"
        (clicked)="confirm()"
      />
    </div>
  </div>
</div>
